import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isMobileView } from "../Utility/Utility";

export function useRestorePage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (isMobileView) {
      const isStartUrl = window.location.search.includes("pwa=true");
      if (!isStartUrl) return;

      const last = localStorage.getItem("lastVisited");

      if (!last || last === "/") return;

      // Prevent infinite loop
      if (window.location.pathname !== last) {
        if (window.location.pathname === "kansas_product/customercartlist") {
          navigate("kansas_product/allproducts", { replace: true });
        } else {
          navigate(last, { replace: true });
        }
      }
    }
  }, []);
}
